require('./insurancesListCard.scss');

// @ vendor
const React = require('react');
const PropTypes = require('prop-types');
const { map } = require('lodash');
const classnames = require('classnames');

// @ core
const { FormattedText } = require('core/i18n').i18n;

// @ commons
const { AccordionHeader } = require('commonsComponents/accordionHeader');
const { AccordionBody } = require('commonsComponents/accordionBody');
const { EmptyState } = require('commonsComponents/emptyState');
const { OKButton } = require('components/commons/OKButton/OKButton');
const { Accordion } = require('commonsComponents/accordion');

// @ components
const InsurancesListCardBodyItem = require('./insurancesListCardBodyItem/insurancesListCardBodyItem');
const InsurancesListCardHeader = require('./insurancesListCardHeader/insurancesListCardHeader');

class InsurancesListCard extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isExpanded: props.expanded
        };

        this.handleToggleAccordion = this.handleToggleAccordion.bind(this);
    }

    handleToggleAccordion() {
        this.setState({ isExpanded: !this.state.isExpanded })
    }

    buildColumns() {
        const { columns } = this.props;

        if (columns.length > 0) {
            const columnsContent = columns.map((column, idx) => {
                const columnClass = classnames('insurances-list-card__columns-item', column.className);

                return (
                    <div key={idx} className={columnClass}>
                        {column.title}
                    </div>
                )
            });

            return (
                <div className="insurances-list-card__columns">
                    <div className="row">
                        {columnsContent}
                    </div>
                </div>
            );
        }
    }

    buildCards() {
        const { cards } = this.props;

        return map(cards, (card, index) => (
            <InsurancesListCardBodyItem
                key={`insurances-list-card-box-item-${index}`}
                title={card.title}
                amount={card.amount}
                currency={card.currency}
                link={card.link}
                subtitle={card.subtitle}
                mortgage={card.mortgage}
            />
        ));
    }

    buildError() {
        const { errorText, handleErrorRetry } = this.props;

        const retryButton = (
            <OKButton id="btn_insurancesLanding_retry" onClick={() => handleErrorRetry()}>
                <FormattedText value="insuranceLanding-retry" />
            </OKButton>
        );

        return (
            <EmptyState
                primaryText={errorText}
                button={retryButton}
                iconType="nointernet-banking" />
        );
    }

    buildContent() {
        const { error, extraLink } = this.props;

        let columnsEl;
        let cardsEl;
        let errorEl;
        let linkEl;

        if (error) {
            errorEl = this.buildError();
        } else {
            columnsEl = this.buildColumns();
            cardsEl = this.buildCards();

            if (extraLink) {
                linkEl = (
                    <div className="insurances-list-card__showmore">
                        <OKButton
                            autoHeight
                            loading={false}
                            modifier="link-complementary"
                            onClick={extraLink.handleClick}
                        >
                            {extraLink.text}
                        </OKButton>
                    </div>
                );
            }
        }

        return (
            <AccordionBody name="AccordionBody">
                {columnsEl}
                {cardsEl}
                {errorEl}
                {linkEl}
            </AccordionBody>
        );
    }

    render() {
        const {
            id,
            expanded,
            title,
            amount,
            icon
        } = this.props;


        const boxClasses = classnames('insurances-list-card', {
            'insurances-list-card--is-expanded': expanded
        });

        return (
            <div className={boxClasses}>
                <Accordion
                    customClassName="insurances-list-card__collapsable"
                    isExpanded={this.state.isExpanded}
                    onClick={this.handleToggleAccordion}
                    id={id}
                >
                    <AccordionHeader name="AccordionHeader">
                        <InsurancesListCardHeader
                            icon={icon}
                            title={title}
                            amount={amount}
                            expanded={expanded}
                        />
                    </AccordionHeader>
                    {this.buildContent()}
                </Accordion>
            </div>
        );
    }
}

InsurancesListCard.propTypes = {
    id: PropTypes.string,
    amount: PropTypes.number,
    title: PropTypes.string,
    cards: PropTypes.array,
    expanded: PropTypes.bool,
    icon: PropTypes.string,
    extraLink: PropTypes.object,
    columns: PropTypes.array,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    handleErrorRetry: PropTypes.func
};

InsurancesListCard.defaultProps = {
    expanded: false,
    columns: [],
    error: false
};
module.exports = InsurancesListCard;
